
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/service_marketbomdome",
      function () {
        return require("private-next-pages/service_marketbomdome/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/service_marketbomdome"])
      });
    }
  